module.exports = __webpack_public_path__ + "static/zz_tall_adams-95a7881de9cb436e3412e8737c44d24b.jpg";